import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

interface ShutdownAlertIconProps {
  width?: number;
  height?: number;
}

const ShutdownAlertIcon = ({ width = 16, height = 16, ...rest }: ShutdownAlertIconProps) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
        fill={token.colorErrorBg}
      />
      <path
        d="M11.1821 11.1821L4.81836 4.81836"
        stroke={token.colorError}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5C10.4853 12.5 12.5 10.4853 12.5 8C12.5 5.51472 10.4853 3.5 8 3.5C5.51472 3.5 3.5 5.51472 3.5 8C3.5 10.4853 5.51472 12.5 8 12.5Z"
        stroke={token.colorError}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShutdownAlertIcon;
